import { defineComponent as _defineComponent } from 'vue'
import type { TranslateResult } from 'vue-i18n'

import GTView from './g-t-view.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'g-ant-button',
  props: {
    text: null
  },
  setup(__props: any) {



return { __sfc: true,GTView }
}

})